import React, { useState, useEffect } from "react";
import OTPInput from "react-otp-input";
import { Typography } from "@mui/material";

import "./portfolio.scss";
import { SecondaryButton } from "../../common/Buttons";
import { useTranslation } from "react-i18next";
import { resendOtp, verifyPhoneNumber } from "../../services/user/UserServices";
import { Toaster, toast } from "react-hot-toast";
import { formatTime, getKeyFromText } from "../../utils/Utilities";

const VerificationCode = ({ back, mfaTokenId, handleMfaTokenId }) => {
  const [OTP, setOTP] = useState("");
  const [time, setTime] = useState(300);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const userId = localStorage.getItem("loggedInUserId");

  function handleChange(OTP) {
    setOTP(OTP);
  }
  const handleSubmit = async () => {
    if (OTP) {
      setIsLoading(true);
      const payload = {
        mfaTokenId,
        OTP,
      };
      const result = await verifyPhoneNumber(payload);
      if (result.success) {
        localStorage.setItem("phoneNumberConfirmed", true);
        window.location = "/";
      } else {
        toast.error(t(getKeyFromText(result?.message)));
        setTime(0);
      }
      setIsLoading(false);
    } else {
      toast.error(t("enter-otp"));
    }
  };
  useEffect(() => {
    if (time === 0) {
      return;
    }
    const interval = setInterval(() => {
      setTime((prevTime) => prevTime - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [time]);

  const handleResendOtp = async () => {
    const payload = {
      userId,
      mfaTokenId,
    };
    const result = await resendOtp(payload);
    if (result.success) {
      setTime(120);
      handleMfaTokenId(result?.payLoad?.mfaToken);
    }
  };

  return (
    <div className="otp-screen">
      <Toaster />
      <div className="content-container">
        <Typography variant="p" color="color.magentaDark1" fontSize="22px">
          {t("step")} 2 {t("from")} 2
        </Typography>
        <br />
        <Typography
          variant="p"
          color="color.magentaDark1"
          fontWeight="bold"
          fontSize="30px"
        >
        {t("confirm-phone")}
        </Typography>
        <div className="otpElements">
          <Typography variant="p" color="color.magentaDark1" fontSize="20px">
          {t("verification-code")}
          </Typography>
          <div className="otp">
          <div className="otp-code">
            <OTPInput
              onChange={handleChange}
              value={OTP}
              inputStyle="inputStyle"
              numInputs={5}
              separator={<span> </span>}
            />
          </div>
          </div>
          <div className="verification-button-a">
          <SecondaryButton
            title={time === 0 ? t("resend") : formatTime(time)}
            bgColor="color.transparent"
            borderRadius="5px"
            width="120px"
            border="1px solid #dfc8db"
            hoverBgColor="color.magentaLight1"
            textTransform="initial"
            padding="0rem"
            height="2.5rem"
            right="0"
            top="100%"
            click={handleResendOtp}
            disabled={time === 0 ? false : true}
          />
        </div>
      </div>
      </div>
      <div>
        <SecondaryButton
          title={t("back")}
          bgColor="color.transparent"
          borderRadius="5px"
          width="180px"
          border="1px solid #dfc8db"
          hoverBgColor="color.magentaLight1"
          textTransform="initial"
          padding="0rem"
          height="3.2rem"
          click={back}
        />
        <SecondaryButton
          title={t("next")}
          bgColor="#E8D7E5"
          borderRadius="5px"
          width="200px"
          marginLeft="10px"
          border="none"
          hoverBgColor="color.magentaLight1"
          click={handleSubmit}
          textTransform="initial"
          padding="0rem"
          height="3.2rem"
        />
      </div>
    </div>
  );
};

export default VerificationCode;
